// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import qs from 'qs';
Vue.prototype.$qs = qs;
// 解决axios与IE不兼容问题
import "babel-polyfill";
Vue.prototype.$http = axios;
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import TreeChart from "vue-tree-chart";
Vue.use(TreeChart);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

//导入iview组件
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(iView);
Vue.use(ElementUI);
Vue.config.productionTip = false

import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify);

//jquery
import $ from 'jquery'
import moment from 'moment';
//使用moment.js日期格式化类库实现日期格式化功能
Vue.filter('datefmt',function(input,fmtstring){
  return moment(input).format(fmtstring);
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js